import React from 'react';

import { Flex } from '@chakra-ui/react';
import { Button, Dropdown, DropdownTrigger, DropdownContent, DropdownItem } from '@mesh.ai/rabbit';

import { Tooltip } from 'uiToolkitV1/Tooltip';
import { TextLabel } from 'uiToolkitV1/Typography/Typography';

interface EllipsisMenuOption {
  label: string;
  onClick?: () => void;
  Icon?: React.FC<any>;
  type?: 'subMenu' | 'default' | 'radio' | 'radioSubMenu';
  subOptions?: Array<{
    label: string;
    onClick: () => void;
    Icon?: React.FC<any>;
    description?: string;
  }>;
}

export const EllipsisMenuActions = ({ options }: { options: EllipsisMenuOption[] }) =>
  options?.map((option) => {
    // Handle default type (icon button only)
    if (option.type === 'default' || !option.type) {
      return (
        <Tooltip label={option.label}>
          <Button
            key={option.label}
            variant="text"
            onClick={option.onClick}
            aria-label={option.label}
            style={{ padding: '0 8px' }}
          >
            {option.Icon ? <option.Icon color="#0D819F" boxSize="24px" /> : option.label}
          </Button>
        </Tooltip>
      );
    }
    // Handle subMenu type (icon button with dropdown)
    if (option.type === 'subMenu' && option.subOptions?.length) {
      return (
        <Dropdown key={option.label}>
          <Tooltip label={option.label}>
            <DropdownTrigger asChild>
              <Button variant="text" aria-label={option.label} style={{ padding: '0 8px' }}>
                {option.Icon ? <option.Icon color="#0D819F" boxSize="24px" /> : option.label}
              </Button>
            </DropdownTrigger>
          </Tooltip>
          <DropdownContent>
            {option.subOptions.map((sub) => (
              <DropdownItem key={sub.label} onSelect={sub.onClick}>
                <Flex flexDir="column">
                  <Flex alignItems="center">
                    {sub.Icon && <sub.Icon mr="8px" color="currentColor" boxSize="24px" />}
                    <span>{sub.label}</span>
                  </Flex>
                  {sub.description && <TextLabel color="text.g2">{sub.description}</TextLabel>}
                </Flex>
              </DropdownItem>
            ))}
          </DropdownContent>
        </Dropdown>
      );
    }
    // Ignore other types for now
    return null;
  }) ?? null;
